import React, { useEffect, useRef } from "react";
import styled from "styled-components";

interface MediaDisplayForWinningItemProps {
  selectedBox: {
    picture: string;
    video: string | null;
  };
}

const BoxContainer = styled.div`
flex: 1 1 auto; /* Flexible growth and shrinkage */
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BoxImage = styled.img`
  width: calc(100% - 8px); /* Adjust width to account for margins */
  height: 64%;
  border-radius: 13px;
  /* background-color: #023; */
  object-fit: contain;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out; /* Add smooth transition effect */
  margin: 4px auto; /* Set auto for equal left and right margins */
`;

const VideoWrapper = styled.video`

  @media (max-width: 400px) {
    width: 100%; /* Adjust for smaller screens */
    height: auto; /* Maintain aspect ratio */
    top: 0; /* Remove negative top for better layout */
    left: 0; /* Center the video */
  }

  width: 150%; /* Increase width beyond its container */
  height: auto; /* Maintain aspect ratio */
  top: -40px;

  border-radius: 13px;
  /* background-color: #023; */
  object-fit: contain;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out; /* Add smooth transition effect */
  margin: 4px auto; /* Set auto for equal left and right margins */
`;


const MediaDisplayForWinningItem: React.FC<MediaDisplayForWinningItemProps> = ({ selectedBox }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.85; // Slow down video playback
    }
  }, []);

  const localization = {
    box_image: "Box Image", // Hardcoded localization string
  };

  return (
    <BoxContainer>
      {selectedBox.video ? (
        <VideoWrapper
          ref={videoRef}
          src={selectedBox.video}
          autoPlay
          muted
          loop
        />
      ) : (
        <BoxImage
          src={selectedBox.picture}
          alt={localization.box_image}
        />
      )}
    </BoxContainer>
  );
};

export default MediaDisplayForWinningItem;
